import { z } from 'zod';
import { VersionState, VersionStateSchema } from '../enumerations/VersionState';
import { IdSchema } from '../resource-base/baseSchemas';
import { msObject } from '../resource-base/msObject';

export const VersionInfoSchema = msObject({
    precedingVersion: IdSchema.nullable(),
    versionState: VersionStateSchema,
    versionNumber: z.string(),
});

export type VersionInfo = z.infer<typeof VersionInfoSchema>;

export const defaultVersionInfo: VersionInfo = {
    precedingVersion: null,
    versionState: VersionState.OPEN,
    versionNumber: '',
};
